export default {
  "fullscreen-center": "_fullscreen-center_14khic",
  "section": "_section_14khic",
  "header": "_header_14khic",
  "title": "_title_14khic",
  "description": "_description_14khic",
  "actions": "_actions_14khic"
};